import { render, staticRenderFns } from "./RecoveriesTable.vue?vue&type=template&id=b9d6393c&"
import script from "./RecoveriesTable.vue?vue&type=script&lang=js&"
export * from "./RecoveriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports